/**
 * Whether the user is a Fearless league admin/employee or not.
 * @param user - The user object to check, or null/undefined if not logged in.
 */
export default function isAdmin(user?: { roles?: string[] } | null): boolean {
    return (user?.roles?.indexOf('admin') ?? -1) > -1;
}
